import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { useHydrating } from "eddev/routing"
import Marquee from "react-fast-marquee"
import { ResponsiveImageFragment } from "../../types.graphql"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { useWindowSize } from "usehooks-ts"

export const meta: BlockMeta = {
  title: "Image Marquee",
  tags: ["#page"],
}

export default defineBlock("content/image-marquee", (props) => {
  const isHydrating = typeof window === "undefined" //useHydrating()
  const { width } = useWindowSize()
  const isMobile = width < 800
  let images = props.images || []

  if (isMobile && images.length > 0 && images.length < 10) {
    // make sure there are at least 10 images
    const currentLength = images.length
    const timesToAdd = Math.ceil(10 / currentLength)
    const newImages: (ResponsiveImageFragment | null)[] = []
    for (let i = 0; i < timesToAdd; i++) {
      newImages.push(...images)
    }
    images = newImages
  }

  return (
    <div className="w-[100vw] overflow-hidden my-blockSpace flex flex-col md:flex-row items-center justify-center gap-4">
      {isHydrating ? (
        <MarqueeImages images={images} />
      ) : (
        <>
          <Marquee autoFill={!isMobile}>
            <MarqueeImages images={images} />
          </Marquee>
          <div className="w-full md:hidden">
            <Marquee autoFill={!isMobile} direction="right">
              <MarqueeImages images={images} />
            </Marquee>
          </div>
        </>
      )}
    </div>
  )
})

const MarqueeImages = ({ images }: { images: (ResponsiveImageFragment | null)[] }) => {
  return (
    <div className="flex flex-nowrap gap-4 items-center justify-center">
      {env.admin && images.length === 0 && (
        <div className="w-full py-5 px-3 rounded-md bg-slate200 text-slate950 type-sans-base-regular">
          No images added. Please add images to display the image marquee.
        </div>
      )}
      {images.map(
        (image, index) =>
          !!image && (
            <div key={index} className="w-logoW h-logoH shrink-0">
              <ResponsiveImage {...image} className="w-logoW h-logoH" objectFit="cover" fadeOnLoad={false} />
            </div>
          ),
      )}
    </div>
  )
}
